/*
 * Live workshop slide registry — "The Unwritten 80% · Cedar & Thread" deck.
 *
 * Single source of truth is ../../../../slides (shared with the facilitator
 * materials): workshop-manifest.json defines order/titles, polls.json defines
 * each slide's poll, and the Markdown files hold the projected content. The old
 * placeholder registry remains at ../slides but is no longer referenced.
 */
import manifest from '../../../../slides/workshop-manifest.json'
import pollsData from '../../../../slides/polls.json'

const rawFiles = import.meta.glob('../../../../slides/*.md', {
  query: '?raw',
  import: 'default',
  eager: true,
})

const rawByName = {}
for (const [path, content] of Object.entries(rawFiles)) {
  rawByName[path.split('/').pop()] = content
}

const pollById = {}
for (const s of pollsData.slides) {
  pollById[s.slideId] = s.poll
}

/**
 * Extract the student-facing content from a slide Markdown file:
 * strip the YAML frontmatter, drop everything from the "## Quiz" section
 * onward (the poll, concealed answer, and presenter notes are not projected),
 * and remove the leading H1 (SlideChrome renders the title separately).
 */
export function extractBody(raw) {
  if (!raw) return ''
  let s = String(raw)
  s = s.replace(/^---\r?\n[\s\S]*?\r?\n---\r?\n/, '')
  const quizIndex = s.search(/\n##\s+Quiz\b/)
  if (quizIndex !== -1) s = s.slice(0, quizIndex)
  s = s.replace(/^\s+/, '').replace(/^#\s+.*\r?\n/, '')
  return s.trim()
}

export const slides = manifest.slides.map((s) => ({
  id: s.id,
  title: s.title,
  file: s.file,
  minutes60: s.minutes60,
  minutes90: s.minutes90,
  bookChapter: s.bookChapter,
  poll: pollById[s.id] || null,
  body: extractBody(rawByName[s.file] || ''),
}))

export function getSlide(id) {
  return slides.find((s) => s.id === id) || null
}

export function getSlideIndex(id) {
  return slides.findIndex((s) => s.id === id)
}
